import {
  BellRing,
  ClipboardList,
  Hammer,
  Home,
  MoreHorizontal,
} from "lucide-react";
import type { LucideIcon } from "lucide-react";
import { NavLink, useLocation } from "react-router-dom";

import { isInMoreSection } from "@/lib/navigation";

interface Tab {
  to: string;
  label: string;
  icon: LucideIcon;
  end?: boolean;
}

const tabs: Tab[] = [
  { to: "/", label: "Home", icon: Home, end: true },
  { to: "/timetable", label: "Timetable", icon: ClipboardList },
  { to: "/announcements", label: "Notices", icon: BellRing },
  { to: "/development", label: "Dev.", icon: Hammer },
  { to: "/more", label: "More", icon: MoreHorizontal },
];

export function BottomNav() {
  const location = useLocation();
  const moreActive = isInMoreSection(location.pathname);

  return (
    <nav
      aria-label="Primary"
      className="fixed bottom-0 left-0 right-0 z-20 border-t border-line bg-paper/95 backdrop-blur-sm sm:hidden"
      style={{ paddingBottom: "env(safe-area-inset-bottom)" }}
    >
      <ul className="grid grid-cols-5">
        {tabs.map((t) => {
          const Icon = t.icon;
          const isMore = t.to === "/more";
          return (
            <li key={t.to}>
              <NavLink
                to={t.to}
                end={t.end ?? false}
                className={({ isActive }) => {
                  const active = isMore ? moreActive : isActive;
                  return `flex min-h-[48px] flex-col items-center justify-center gap-0.5 py-2 text-[10px] uppercase tracking-wider transition-colors ${
                    active ? "text-masjidGreen" : "text-muted"
                  }`;
                }}
                aria-label={t.label}
              >
                <Icon size={20} strokeWidth={1.5} aria-hidden />
                <span>{t.label}</span>
              </NavLink>
            </li>
          );
        })}
      </ul>
    </nav>
  );
}
